/**
 * ResultEffects.js — Orchestrator
 * Renders the three Effects sub-sections:
 *   1. EffectsIndividual  — one column per skill, Total*
 *   2. EffectsColorTotals — grouped by base color (Orange/Green/Purple/Red/Blue)
 *   3. EffectsSpecial     — Evolution/Gold/Unique/Inherited/Scenario Gold, no total
 */
import React from 'react';
import { BASE_COLORS, SPECIAL_COLORS } from './EffectsPanel/effectsHelpers';
import EffectsIndividual from './EffectsPanel/EffectsIndividual';
import EffectsColorTotals from './EffectsPanel/EffectsColorTotals';
import EffectsSpecial from './EffectsPanel/EffectsSpecial';

const ResultEffects = ({ selectedSkills }) => {
    if (!selectedSkills || selectedSkills.length === 0) return null;

    const baseSkills = selectedSkills.filter(s => BASE_COLORS.includes(s.color));
    const specialSkills = selectedSkills.filter(s => SPECIAL_COLORS.includes(s.color) || !s.color);

    return (
        <div className="space-y-3">
            <EffectsIndividual selectedSkills={selectedSkills} />
            <EffectsColorTotals baseSkills={baseSkills} />
            <EffectsSpecial specialSkills={specialSkills} />
        </div>
    );
};

export default ResultEffects;
